<template>
  <div v-bind:class="['card', 'card-chart', getPulseClass(alertActive)]">
    <div class="card-header" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <div class="card-body">
      <slot name="title-content">
        <div class="row">
          <div class="col-sm-7">
            <div class="numbers pull-left">
              <slot name="title"></slot>
            </div>
          </div>
          <div class="col-sm-5">
            <div class="pull-right">
              <slot name="title-label"></slot>
            </div>
          </div>
        </div>
      </slot>
      <slot name="subtitle"></slot>
      <component :is="chartComponent"
                 :chart-id="chartId"
                 :labels="chartData.labels"
                 :color="color"
                 :title="chartTitle"
                 :extra-options="chartOptions"
                 :height="chartHeight"
                 :datasets="chartData.datasets"
                 :data="chartData.series">
      </component>
    </div>

    <div class="card-footer">
      <slot name="footer">
        <hr>
        <div v-if="!pdfPrint" class="row">
          <div class="col-sm-9 footer-container">
            <div class="footer-title text-truncate h-title">
              <slot name="footer-title"></slot>
            </div>
          </div>
          <div class="col-sm-3">
            <div class="pull-right">
              <slot name="footer-right"></slot>
            </div>
          </div>
        </div>
        <div v-else class="row">
          <div class="col-sm-12 footer-container">
            <div class="footer-title text-truncate h-title">
              <slot name="footer-title"></slot>
            </div>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>
<script>
  import BarChart from '../Charts/BarChart'
  import LineChart from '../Charts/LineChart'
  import DoughNutChart from '../Charts/DoughnutChart'
  import PieChart from '../Charts/PieChart'
  export default {
    name: 'chart-card',
    components: {
      LineChart,
      BarChart,
      DoughNutChart,
      PieChart
    },
    props: {
      footerText: {
        type: String,
        default: '',
        description: 'Card footer text'
      },
      headerTitle: {
        type: String,
        default: 'Chart title',
        description: 'Card header title'
      },
      chartType: {
        type: String,
        default: 'Line',
        description: 'Chart type (Line|Pie|Bar)'
      },
      chartOptions: {
        type: Object,
        default: () => {
          return { responsive: true, maintainAspectRatio: false }
        },
        description: 'Chart options. Will be sent as extra options to Line|Pie|Bar chart components'
      },
      chartTitle: {
        type: String,
        description: 'Chart title'
      },
      chartHeight: {
        type: Number,
        default: 250,
        description: 'Chart height'
      },
      chartData: {
        type: Object,
        default: () => {
          return {
            labels: [],
            series: []
          }
        },
        description: 'Chart data. Should contain `series` and `labels` or `datasets` and `labels`'
      },
      chartId: String,
      color: {
        type: String,
        default: '#6bd098',
        description: 'Chart color'
      },
      pdfPrint: {
        type: Boolean,
        default: false
      },
      alertActive: {
        type: Number,
        default: 0
      }
    },
    data() {
      return {
        chartComponents: {
          Line: 'line-chart',
          Bar: 'bar-chart',
          Doughnut: 'doughnut-chart',
          Pie: 'pie-chart',
          default: 'line-chart'
        }
      }
    },
    computed: {
      chartComponent(){
        return this.chartComponents[this.chartType] || this.chartComponents.default;
      }
    },
    methods: {
      getPulseClass(alertActive) {
        if (alertActive < 0) {
          return 'pulse-red'
        } else if (alertActive > 0) {
          return 'pulse-green'
        } else {
          return ''
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
.card-chart {
  .card-body{
    padding-bottom: 0;
  }
  .card-footer{
    padding-top: 0;
    white-space: nowrap;

    .footer-container {
      display: flex;
      align-items: center;
    }

    .h-title {
      min-height: 1.3rem;
    }
  }
  hr {
    margin-top: 0;
  }
}

.pulse-red {
  box-shadow: 0 0 0 rgba(255,0,0, 0.4);
  animation: pulse-red 3s infinite;

  @-webkit-keyframes pulse-red {
    0% {
      -webkit-box-shadow: 0 0 0 2px rgba(255,0,0, 0.8);
    }
    50% {
        -webkit-box-shadow: 0 0 0 5px rgba(255,0,0, 0.4);
    }
    100% {
        -webkit-box-shadow: 0 0 0 2px rgba(255,0,0, 0.2);
    }
  }
  @keyframes pulse-red {
    0% {
      -moz-box-shadow: 0 0 0 2px rgba(255,0,0, 0.8);
      box-shadow: 0 0 0 2px rgba(255,0,0, 0.8);
    }
    50% {
        -moz-box-shadow: 0 0 0 5px rgba(255,0,0, 0.4);
        box-shadow: 0 0 0 5px rgba(255,0,0, 0.4);
    }
    100% {
        -moz-box-shadow: 0 0 0 2px rgba(255,0,0, 0.2);
        box-shadow: 0 0 0 2px rgba(255,0,0, 0.2);
    }
  }
}

.pulse-green {
  box-shadow: 0 0 0 rgba(0,152,0, 0.4);
  animation: pulse-green 3s infinite;

  @-webkit-keyframes pulse-green {
    0% {
      -webkit-box-shadow: 0 0 0 2px rgba(0,152,0, 0.8);
    }
    50% {
        -webkit-box-shadow: 0 0 0 5px rgba(0,152,0, 0.4);
    }
    100% {
        -webkit-box-shadow: 0 0 0 2px rgba(0,152,0, 0.2);
    }
  }
  @keyframes pulse-green {
    0% {
      -moz-box-shadow: 0 0 0 2px rgba(0,152,0, 0.8);
      box-shadow: 0 0 0 2px rgba(0,152,0, 0.8);
    }
    50% {
        -moz-box-shadow: 0 0 0 5px rgba(0,152,0, 0.4);
        box-shadow: 0 0 0 5px rgba(0,152,0, 0.4);
    }
    100% {
        -moz-box-shadow: 0 0 0 2px rgba(0,152,0, 0.2);
        box-shadow: 0 0 0 2px rgba(0,152,0, 0.2);
    }
  }
}
</style>
